import { Component, signal } from '@angular/core';

@Component({
    selector: 'app-hero-card',
    imports: [],
    templateUrl: './hero-card.component.html'
})
export class HeroCardComponent {
  readonly days = signal([
    { label: 'L', num: 12 },
    { label: 'M', num: 13 },
    { label: 'X', num: 14, active: true },
    { label: 'J', num: 15 },
    { label: 'V', num: 16 },
  ]);

  readonly nextEvent = signal({
    title:    'Cumpleaños de Lucas',
    subtitle: 'Sala Arcoíris · 3h · 16:00–19:00',
    month:    'Mayo 2026',
    price:    '120 €',
    capacity: '30 pers.',
  });
}
